export default "__VITE_ASSET__Wu6EO$kI__"